<nz-date-picker 
    [nzDisabled]="field.templateOptions.disabled" 
    [formControl]="formControl"
    [nzShowTime]="true"
    [nzAllowClear]="false"
>
</nz-date-picker>